import { eObstacleType } from "../ObstacleTypes";
import { Obstacle } from "../Obstacle";
import { ObstacleMapData } from "../ObstacleMapData";
import { ViewCellMapRow } from "../../View/ViewCellMapRow";
import { Player } from "../../Player/Player";
import { ShiftingObsSettings } from "./ObstacleSettings";
import { SoundManager } from "../../../../Utils/SoundManager";



export class ShiftingObstacle extends Obstacle {
    /**
     * Probiha presun
     */
    private static readonly FLAG_SHIFTING = 0x00010000;

    /**
     * Flag oznacujici dokonceni presunu prekazky
     */
    private static readonly FLAG_SHIFT_COMPLETE = 0x00020000;

    /**
     * Nastaveni prekazky
     */
    protected _settings: ShiftingObsSettings;

    /**
     * Vychozi lokalni pozice prekazky
     */
    private _startPos: pc.Vec3;

    /**
     * Cilova lokalni pozice prekazky
     */
    private _endPos: pc.Vec3;

    /**
     * Aktualni lokalni pozice prekazky
     */
    protected _pos: pc.Vec3;

    /**
     * Pozice na ose Z, kdy dojde k zahajeni presunu
     */
    private _shiftPosS: number;

    /**
     * Pozice na ose Z, kdy dojde k dokonceni presunu
     */
    private _shiftPosE: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super(eObstacleType.shifting);

        // Sfx
        SoundManager.createSoundComponent(this._entity, {
            positional: true,
            distanceModel: pc.DISTANCE_LINEAR,
            maxDistance: 10
        });

        // Pozice
        this._startPos = new pc.Vec3();
        this._endPos = new pc.Vec3();
        this._pos = new pc.Vec3();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(mapData: ObstacleMapData, row: ViewCellMapRow): void {
        super.init(mapData, row);

        // Ulozit nastaveni
        this._settings = mapData.settings as ShiftingObsSettings;

        // Pozice prekazky        
        this._startPos.copy(this._entity.getLocalPosition());
        this._startPos.add(this._settings.startPosOffset);
        this._entity.setLocalPosition(this._startPos);

        this._endPos.copy(this._startPos);
        this._endPos.add(this._settings.shiftVec);

        this._pos.copy(this._startPos);

        if (!this._settings.deadly)
            this._flags &= ~Obstacle.FLAG_CHECK_COLLISION;

        if (this._settings.startVisible) {
            this._entity.model.show();
        }
        else {
            this._entity.model.hide();
        }

        // Pozice zacatku aktivace a konce aktivace
        this._shiftPosS = row.z + this._settings.shiftPlDisS;
        this._shiftPosE = row.z + this._settings.shiftPlDisE;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!super.update())
            return false;

        if ((this._flags & ShiftingObstacle.FLAG_SHIFT_COMPLETE) != 0)
            return true;

        let plZ = Player.instance.position.z;
        let progress = (this._shiftPosS - plZ) / (this._shiftPosS - this._shiftPosE);

        if (progress > 0) {
            if ((this._flags & ShiftingObstacle.FLAG_SHIFTING) == 0) {
                this._flags |= ShiftingObstacle.FLAG_SHIFTING;

                if (!this._settings.startVisible)
                    // Zobrazit prekazku
                    this._entity.model.show();
            }

            let easedProg: number;

            if (progress >= 1) {
                progress = 1;
                easedProg = 1;
                this._flags &= ~ShiftingObstacle.FLAG_SHIFTING;
                this._flags |= ShiftingObstacle.FLAG_SHIFT_COMPLETE;
            }
            else {
                easedProg = this._settings.shiftEase(progress);
            }

            this.processShift(progress, easedProg);
        }

        return true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected processShift(realProg: number, easedProg: number): void {
        this._pos.x = this._startPos.x + (this._endPos.x - this._startPos.x) * easedProg;
        this._pos.y = this._startPos.y + (this._endPos.y - this._startPos.y) * easedProg;
        this._pos.z = this._startPos.z + (this._endPos.z - this._startPos.z) * easedProg;

        this._entity.setLocalPosition(this._pos);
    }
}